import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const store = ({ modal }) => modal;

const makeSelectIsModalOpened = () => createSelector(
  store,
  ({ opened }) => opened,
);

export {
  makeSelectIsModalOpened,
};
